import { render, staticRenderFns } from "./AchievementScoreRange0to6.vue?vue&type=template&id=ea513bae&scoped=true"
import script from "./AchievementScoreRange0to6.vue?vue&type=script&lang=js"
export * from "./AchievementScoreRange0to6.vue?vue&type=script&lang=js"
import style0 from "./AchievementScoreRange0to6.vue?vue&type=style&index=0&id=ea513bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea513bae",
  null
  
)

export default component.exports